import { ThemePalette } from 'shared-components/core/mixins';

import { SnackbarConfiguration, SnackbarPrimaryConfiguration } from '../../models';

/**
 * Array of supported colors in snackbar
 */
export const supportedSnackbarColors: ThemePalette[] = ['primary', 'info', 'warning', 'success', 'error'];

/**
 * Check if configuration is for primary color
 * @param {SnackbarConfiguration} configuration - configuration to check
 * @returns {boolean} if configuration is for primary color
 */
export const isPrimary = (configuration: SnackbarConfiguration): configuration is SnackbarConfiguration & { primaryConfiguration: SnackbarPrimaryConfiguration } =>
  configuration.color === 'primary';

/**
 * Validate if color is on supported color
 * @param {ThemePalette} color - color to check
 * @throws when color is not considered as supported color
 */
export const checkUnsupportedColor = (color: ThemePalette): void => {
  if (!supportedSnackbarColors.includes(color)) {
    throw new Error(`[Snackbar] Unsupported color "${color}" for snackbar`);
  }
};
